import useSeo from "@/lib/useSeo";
import PageHero from "@/components/site/PageHero";
import Process from "@/components/sections/Process";
import CtaBanner from "@/components/site/CtaBanner";

export default function Ablauf() {
    useSeo({
        title: "Ablauf – So arbeiten wir | Alpen Reinigung Innsbruck",
        description:
            "Vom Erstkontakt bis zur Reinigung: So läuft eine Zusammenarbeit mit Alpen Reinigung in Innsbruck und Tirol – transparent, planbar und fair.",
        path: "/ablauf",
    });
    return (
        <div>
            <PageHero
                eyebrow="Ablauf"
                title="In drei Schritten zu sauberen Ergebnissen"
                lead="Klare Kommunikation, planbare Termine und saubere Dokumentation – so machen wir die Zusammenarbeit für Sie einfach."
                breadcrumbs={[{ label: "Ablauf" }]}
            />
            <Process />
            <CtaBanner />
        </div>
    );
}
